// LAP-768 — Agrégation des sources Life du conseiller social / relationnel.
//
// Même pattern que `fetchProAdvisorSources` (LAP-767) : on isole chaque
// endpoint (catch indépendant) pour qu'un endpoint absent ne fasse pas tomber
// tout l'agrégat. `buildSocialAdvisor` produit alors un diagnostic partiel mais
// exploitable.
//
// Source principale : /api/Social/dashboard/ qui renvoie l'agrégat déjà
// consolidé du tableau de bord relationnel (overview, repartition, evolution,
// key_relations, suggested_tasks, insights). On le passe brut à
// buildSocialAdvisor qui en dérive la note /100 et le diagnostic.
import { makeGetRequest } from 'utils/api'

/**
 * Récupère les sources nécessaires à `buildSocialAdvisor`.
 *
 * @param {object} fallbackUser - profil Redux à utiliser si /api/user/user/
 *   échoue.
 * @returns {Promise<object>} { user, dashboard }
 */
export async function fetchSocialAdvisorSources(fallbackUser = {}) {
  const safeGet = async (path) => {
    try {
      const r = await makeGetRequest(path, {}, true)
      return r?.data ?? null
    } catch (_) {
      return null
    }
  }

  const [userData, dashboard] = await Promise.all([
    safeGet('/api/user/user/'),
    safeGet('/api/Social/dashboard/'),
  ])

  return {
    user: userData || fallbackUser || {},
    dashboard: dashboard || {},
  }
}

/**
 * LAP-768 — Récupère l'historique réel des recommandations sociales
 * (si le backend l'expose un jour, miroir du pro / écologie). Toléré vide.
 *
 * @returns {Promise<Array>} liste de recommandations (peut être vide).
 */
export async function fetchSocialAdviceHistory() {
  try {
    const r = await makeGetRequest('/api/Social/dashboard/?history=true', {}, true)
    const payload = r?.data
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.results)) return payload.results
    if (Array.isArray(payload?.history)) return payload.history
    return []
  } catch (_) {
    return []
  }
}
